export const isCancelScheduledValuesAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'cancelScheduledValues';
};
//# sourceMappingURL=cancel-scheduled-values-automation-event.js.map